import React, { createContext, useReducer, useContext } from "react";
import AppReducer from "./AppReducer";

const user = JSON.parse(sessionStorage.getItem("user"));
const userparent = JSON.parse(sessionStorage.getItem("userparent"));


const initialState = {
  Profileinfo: null,
  token: null,
  user: user,
  userparent: userparent,
  transactionLoader: false,
  accessData: null,
  accessDataemp: null,
};

const GlobalContext = createContext(initialState);

export const GlobalProvider = ({ children }) => {
  const [state, dispatch] = useReducer(AppReducer, initialState);

  // Action creators
  const setTransactionLoaderState = (payload) =>
    dispatch({ type: "SET_TRANSACTION_LOADER", payload });

  const setToken = (payload) => dispatch({ type: "SET_TOKEN", payload });

  const setProfileinfo = (payload) =>
    dispatch({ type: "SET_MY_ACCOUNT_INFO", payload });

  const setMyAccountInfo = (payload) => {
    sessionStorage.setItem("accountDetails", JSON.stringify(payload));
    dispatch({ type: "SET_MY_ACCOUNT_INFO_DEVELOPER", payload });
  };

  const setUserInfo = (payload) => {
    sessionStorage.setItem("user", JSON.stringify(payload));
    dispatch({ type: "SET_USER_INFO", payload });
  };

  const setUserParent = (payload) => {
    sessionStorage.setItem("userparent", JSON.stringify(payload));
    dispatch({ type: "SET_USER_PARENT", payload });
  };

  const setAccessData = (payload) =>
    dispatch({ type: "SET_ACCESS_DATA", payload });

  const setAccessemployeData = (payload) =>
    dispatch({ type: "SET_ACCESS_DATA_EMP", payload });

  return (
    <GlobalContext.Provider
      value={{
        ...state,
        setTransactionLoaderState,
        setToken,
        setProfileinfo,
        setMyAccountInfo,
        setUserInfo,
        setUserParent,
        setAccessData,
        setAccessemployeData,
      }}
    >
      {children}
    </GlobalContext.Provider>
  );
};

export { GlobalContext };